const FrontPage = ({ data }) => {
    return (
        <>
            <div className='FrontPage__Screen__Background'>
                {data?.isActiveWomensMode ? (
                    <img src='/img/games/runtogoal/background-1.png' className='FrontPage__Screen__Background__Image' />
                ) : (
                    <img src='/img/games/runtogoal/background-1.png' className='FrontPage__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage__Screen__Container">
                <img src='/img/page/xolos-five.png' className='FrontPage__Screen__Container__Logo' />

                <p className="FrontPage__Screen__Container__Title">HAZLE LA LUCHA</p>

                <div className="FrontPage__Screen__Container__Players">
                    <img src="/img/games/quizz/wrestling/lucho.png" className="FrontPage__Screen__Container__Players__Image" />
                    <img src="/img/games/quizz/wrestling/tuna.png" className="FrontPage__Screen__Container__Players__Image" />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</footer>
        </>
    )
}

export { FrontPage };